import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { type Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class AdminHttpService {
	private httpClient = inject<HttpClient>(HttpClient);

	private baseUrl = environment.portalApi.uri + '/admin';

	public refreshCostCenters = (): Observable<number> =>
		this.httpClient
			.post<unknown>(
				`${ this.baseUrl }/refreshCostCenters`,
				{},
				{ observe: 'response' }
			)
			.pipe(map((response) => response.status));

	public refreshAfes = (): Observable<number> =>
		this.httpClient
			.post<unknown>(
				`${ this.baseUrl }/refreshAfes`,
				{},
				{ observe: 'response' }
			)
			.pipe(map((response) => response.status));

	public refreshBuyers = (): Observable<number> =>
		this.httpClient
			.post<unknown>(
				`${ this.baseUrl }/refreshBuyers`,
				{},
				{ observe: 'response' }
			)
			.pipe(map((response) => response.status));

	public migrateBuyer = (buyer: string): Observable<number> => {
		return this.httpClient
			.post<unknown>(
				`${ this.baseUrl }/migrateBuyer`,
				{},
				{
					observe: 'response',
					params: { buyer }
				}
			)
			.pipe(map((response) => response.status));
	};

	public syncBuyerSiteDepartments = (): Observable<number> =>
		this.httpClient
			.post<unknown>(
				`${ this.baseUrl }/syncBuyerSiteDepartments`,
				{},
				{ observe: 'response' }
			)
			.pipe(map((response) => response.status));

	public runSalesOrderGapMonitor = (): Observable<number> =>
		this.httpClient
			.post<unknown>(
				`${ this.baseUrl }/runSalesOrderGapMonitor`,
				{},
				{ observe: 'response' }
			)
			.pipe(map((response) => response.status));

	public refreshOrderedByNames = (): Observable<number> =>
		this.httpClient
			.post<unknown>(
				`${ this.baseUrl }/refreshOrderedByNames`,
				{},
				{ observe: 'response' }
			)
			.pipe(map((response) => response.status));
}
